export function isDev() {
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === "" || hostname === "goat.botb.it" || hostname === "goat2.botb.it") {
        return true;
    }
    return false;
}